<template>
  <div class="payment-success container py-5">
    <div class="card shadow-sm">
      <div class="card-body text-center py-5">
        <div class="success-icon mb-4">
          <i class="fas fa-check-circle text-success fa-5x"></i>
        </div>
        <h1 class="card-title">Pembayaran Berhasil!</h1>
        <p class="card-text mb-4">Terima kasih! Pembayaran Anda telah berhasil diproses dan langganan Anda sekarang aktif.</p>
        <div v-if="loading" class="text-center mb-3">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
          <p class="mt-2">Mengaktifkan langganan Anda...</p>
        </div>
        <div v-if="error" class="alert alert-danger">
          {{ error }}
        </div>
        <div v-if="success" class="alert alert-success">
          {{ success }}
        </div>
        <div class="mt-4">
          <router-link to="/" class="btn btn-primary me-3">Kembali ke Beranda</router-link>
          <router-link to="/my-reads" class="btn btn-outline-primary">Mulai Membaca</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'PaymentSuccess',
  data() {
    return {
      loading: false,
      error: null,
      success: null,
      orderId: null
    };
  },
  mounted() {
    // Extract order ID from the URL if present
    const urlParams = new URLSearchParams(window.location.search);
    this.orderId = urlParams.get('order_id');
    
    if (this.orderId) {
      this.updateSubscriptionStatus();
    }
  },
  methods: {
    async updateSubscriptionStatus() {
      this.loading = true;
      this.error = null;
      
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          this.error = 'Sesi Anda telah berakhir. Silakan login kembali.';
          this.loading = false;
          return;
        }

        const response = await axios.post(
          `${process.env.VUE_APP_API_BASE_URL}/api/subscriptions/confirm-payment/`,
          { order_id: this.orderId },
          {
            headers: {
              'Authorization': `Bearer ${token}`
            }
          }
        );

        if (response.data && response.data.status === 'success') {
          this.success = 'Langganan Anda telah berhasil diaktifkan!';
          // Update user subscription status in local storage if needed
          const userData = JSON.parse(localStorage.getItem('user') || '{}');
          if (userData) {
            userData.is_subscribed = true;
            localStorage.setItem('user', JSON.stringify(userData));
          }
        } else {
          this.error = 'Terjadi kesalahan saat mengaktifkan langganan. Silakan hubungi dukungan.';
        }
      } catch (err) {
        console.error('Error updating subscription:', err);
        this.error = err.response?.data?.message || 'Terjadi kesalahan saat memproses pembayaran.';
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.payment-success {
  max-width: 768px;
  margin: 0 auto;
}

.success-icon {
  color: #28a745;
}

.card {
  border-radius: 10px;
  border: none;
}

.alert {
  border-radius: 8px;
}
</style>